import React, { memo } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import classNames from 'classnames';
import { ResponsiveBar } from '@nivo/bar';
import sortBy from 'lodash/sortBy';

import { toJS } from 'src/utils/ChangeSpy';
import { getStatsDealsByYears } from 'src/actions/statistics';
import { Spinner } from 'src/components/helpers/Spinner';
import { countAddonKey, countPlatformKey, yearKey, defaultBarConfig } from './ChartConfig';

import style from './style.module.css';

const EXTENDED_STATS_YEARS_COUNTS = 10;
const LEFT_MARGIN = 11;

const TransactionsByYearsChart = ({ data, getStatsDealsByYears }) => {
  const yearsCounts = toJS(data.getIn(['dealsClosedByYears', 'yearsCounts']));
  const { isFetching } = toJS(data.get('dealsClosedByYears'));

  const getExtendedData = () => {
    getStatsDealsByYears(true);
  };

  const isVisibleMoreButton = !isFetching && yearsCounts.length && yearsCounts.length < EXTENDED_STATS_YEARS_COUNTS;

  const chartData = yearsCounts.map(data => ({
    [yearKey]: data.year,
    [countAddonKey]: data.countAddon,
    [countPlatformKey]: data.countPlatform,
  }));

  const sortedChartData = sortBy(chartData, [yearKey]);

  const chartMaxValue = sortedChartData.reduce((value, data) => {
    const maxValue = data[countAddonKey] + data[countPlatformKey];

    return value > maxValue ? value : maxValue;
  }, 0);

  const axisLeftMargin = String(chartMaxValue).length * LEFT_MARGIN;

  const spinner = isFetching ? <Spinner className="bg-white" /> : null;

  return (
    <div className={style.host}>
      <div className={classNames(style.header, 'flex-grid')}>
        <p className="h5 text-bold pl10">Transactions Per Year</p>
        {isVisibleMoreButton && (
          <p className="h5 text-bold pr10">
            <button
              aria-label="more"
              className={classNames(style.moreButton, 'no-border')}
              onClick={getExtendedData}
              type="button"
            >
              More...
            </button>
          </p>
        )}
      </div>
      <div className="bg-white p20">
        <div className={style.chartWrapper}>
          {isFetching === false && (
            <ResponsiveBar
              {...defaultBarConfig}
              data={sortedChartData}
              margin={{ top: 10, right: 0, bottom: 40, left: axisLeftMargin }}
              maxValue={chartMaxValue}
            />
          )}
          {spinner}
        </div>
      </div>
    </div>
  );
};

TransactionsByYearsChart.propTypes = {
  data: PropTypes.instanceOf(Map).isRequired,
};

const mapActionToProps = {
  getStatsDealsByYears,
};

export default connect(null, mapActionToProps)(memo(TransactionsByYearsChart));
